'use strict';

import './UserCards.less';

import React from 'react';
import PropTypes from 'prop-types';

import MessageModal from 'ck-core-client/source/ui/MessageModal.jsx';
import UserCard from './UserCard';
import RoundButton from 'ck-core-client/source/ui/RoundButton';
import UserCardsLang from './UserCardsLang';
import UserManager from 'ck-core-client/source/managers/UserManager';
import langToReactElements from 'ck-core-client/source/functions/langToReactElements';
import Frame from 'ck-core-client/source/ui/Frame';

import _ from 'lodash';

export default class UserCards extends React.Component {
	constructor(props) {
		super(props);

		this.handleLogout = this.handleLogout.bind(this);
	}

	async handleLogout() {
		if (this.props.isBillingOnlyUser) {
			let modal;

			const logoutButton = (
				<RoundButton
					size="small"
					handleClick={async () => {
						await UserManager.mod().logout();

						this.props.handleCloseModal(modal);

						Frame.mod().navigate('/login');
					}}
					text={'Logout'}
					colour={'red'}
				/>
			);

			modal = (
				<MessageModal
					className="logout"
					message={langToReactElements(UserCardsLang.LOGOUT_BILLING_ONLY_PROMPT)}
					title={UserCardsLang.CONFIRM_LOGOUT_TITLE}
					buttons={[logoutButton]}
				/>
			);

			this.props.handleAddModal(modal);
		} else {
			await UserManager.mod().logout();
			Frame.mod().navigate('/login');
		}
	}

	render() {
		return (
			<div className="UserCards">
				<div className="header">Accounts</div>
				<div>
					{_.map(this.props.cards, card => {
						return (
							<UserCard
								key={card.id}
								{...card}
								handleAddModal={this.props.handleAddModal}
								handleLink={formData => this.props.handleLink(card.id, formData)}
								handleLogin={this.props.handleLogin.bind(null, card.id)}
								handleUnlink={this.props.handleUnlink.bind(null, card.id)}
							/>
						);
					})}
				</div>
				<div className="logout">
					<RoundButton colour="red" text="Logout" size="tiny" handleClick={this.handleLogout} />
				</div>
				{_.some(this.props.cards, card => !card.userId) && <div className="giftInfo" />}
			</div>
		);
	}
}

const linkedUserData = PropTypes.shape({
	id: PropTypes.string.isRequired,
	userId: PropTypes.number.isRequired,
	name: PropTypes.string.isRequired
});

const linkPendingUserData = PropTypes.shape({
	id: PropTypes.string.isRequired,
	userId: PropTypes.number.isRequired,
	name: PropTypes.string.isRequired
});

const unlinkedUserData = PropTypes.shape({
	id: PropTypes.string.isRequired,
	giftHref: PropTypes.string.isRequired,
	giftPdfHref: PropTypes.string.isRequired
});

UserCards.propTypes = {
	cards: PropTypes.arrayOf(
		PropTypes.oneOfType([linkedUserData, unlinkedUserData, linkPendingUserData])
	).isRequired,
	handleLogin: PropTypes.func.isRequired,
	handleLink: PropTypes.func.isRequired,
	handleUnlink: PropTypes.func.isRequired,
	handleAddModal: PropTypes.func.isRequired,
	handleCloseModal: PropTypes.func.isRequired,
	isBillingOnlyUser: PropTypes.bool
};
